<template>

  <v-container fluid class="px-0 page page-vehicle-item">

    <!-- Notifications -->
    <div class="notification-area">
      <data-editor-feedback
          resource="vehicle"
          :autoCloseAfterMillis="5000" />
    </div>

    <!-- Page Content -->
    <v-container fluid>
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
import DataEditorFeedback from '@/components/app/DataEditorFeedback'

export default {
  name: 'VehicleRootPage',

  components: {
    DataEditorFeedback
  },

  props: {
    vehicleId: {
      type: String,
      default: null
    }
  }
}
</script>

<style>
</style>
